import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { getS3URL } from "../../../../_helpers";
import ChapterVideo from "./chapterVideo";
import ChapterDocument from "./chapterDocument";
import { MediaTypes, documentTypeUrl } from "../../../../_constants/staticData";
import axiosInstance from "../../../../axios";
import Button from "../../../Other/element/Button";
import Image from "../../../Other/element/Image";
import ChapterImagePreview from "./chapterImagePreview";

const CourseChapter = ({
  index,
  title,
  content,
  view,
  status,
  TimeConversion,
  ID,
  updateChapterData,
  sectionId,
  acknowledge,
  fetchData,
  videoLink,
  scroms,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [duration, setDuration] = useState();
  const [getDocument, setGetDocument] = useState([]);
  const [show, setShow] = useState(false);
  const [getVideo, setGetVideo] = useState([]);
  const [viewDocument, setViewDocument] = useState();
  const [chapterCompletion, setChapterCompletion] = useState(acknowledge);
  const [secondaryCompletion, setSecondaryCompletion] = useState(false);
  const [mappedPreviewImage, setMappedPreviewImage] = useState([]);
  const [isImageShow, setIsImageShow] = useState(false);
  const [mapped, setMapped] = useState([]);
  const childCompRef = useRef();
  const firstRun = useRef(true);

  useEffect(() => {
    let videoList = [];
    let duration = [];
    let document = [];

    view.forEach((element) => {
      if (MediaTypes.videoType.includes(element.fileExt) || element.videoLink) {
        videoList.push(element);
        duration.push(element.duration);
      } else if (MediaTypes.documentTypes.includes(element.fileExt)) {
        document.push({
          name: getS3URL(element.fileName),
          type: element.fileExt,
        });
      } else if (MediaTypes?.imageTypes.includes(element.fileExt)) {
        document.push({
          name: getS3URL(element.fileName),
          type: element.fileExt,
        });
      }
    });

    setGetVideo(videoList);
    setDuration(duration);
    setGetDocument(document);
  }, [view]);

  const documentViewerHandler = (type) => {
    setMapped(
      getDocument.filter((item) => {
        return item.type === type;
      })
    );
    setShow(true);
  };

  const imagePreviewHandler = (type) => {
    setMappedPreviewImage(
      getDocument.filter((item) => {
        return item.type === type;
      })
    );
    setIsImageShow(!isImageShow);
  };

  const closeHandler = () => {
    setShow(!show);
  };

  const imagePreviewCloseHandler = () => {
    setIsImageShow(!isImageShow);
  };
  useEffect(() => {
    if (childCompRef.current) {
      childCompRef.current.acknowledgeCompleteChapter();
    }
  }, [chapterCompletion]);

  const courseChapterCompletion = () => {
    axiosInstance
      .post(
        "course/section/progress",
        JSON.stringify({
          courseDetailId: sectionId,
          isFinished: chapterCompletion,
        }),

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        fetchData(ID);
      })
      .catch((res) => console.log(res));
  };

  const completionHandler = () => {
    setChapterCompletion(!chapterCompletion);
    setSecondaryCompletion(!secondaryCompletion);
  };
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    courseChapterCompletion();
  }, [secondaryCompletion]);
  return (
    <div className="main-accordion-title" key={index}>
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div>{isActive ? "-" : "+"}</div>
        <div className="chapter-title">{title}</div>
        <div className="getTime">
          <span> {chapterCompletion ? "COMPLETE" : ""}</span>
          {TimeConversion(duration)}
        </div>
      </div>

      {isActive && (
        <div className="accordion-content">
          <div
            className="course-description"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {getVideo &&
            getVideo.length > 0 &&
            getVideo.map((fileItem, index) => (
              <div key={index}>
                <ChapterVideo
                  data={getS3URL(fileItem.fileName)}
                  details={fileItem}
                  checked={chapterCompletion}
                  ref={childCompRef}
                  videoLink={undefined}
                />
              </div>
            ))}
          {videoLink && (
            <ChapterVideo
              checked={chapterCompletion}
              ref={childCompRef}
              videoLink={videoLink}
            />
          )}

          {scroms &&
            scroms.map((items) => (
              <iframe
                src={`https://scorm-edusity.s3.us-east-2.amazonaws.com/${items.entryPoint}`}
              />
            ))}

          <div className="sorted-content">
            <>
              {getDocument?.length > 0 && (
                <div className="no-video">
                  <Button
                    className="btn btn-view-doc border-1"
                    title=" View Document"
                    handleClick={() => setViewDocument(!viewDocument)}
                  />
                </div>
              )}
            </>

            {viewDocument && (
              <div className="document">
                <>
                  {getDocument && (
                    <>
                      {getDocument
                        .filter((items) => items.type === "pdf")
                        .map((ele) => (
                          <div>
                            <Image
                              url={documentTypeUrl.pdf}
                              alt="logo"
                              handleClick={() => documentViewerHandler("pdf")}
                            />
                          </div>
                        ))}

                      {getDocument
                        .filter((items) => items.type === "xlsx")
                        .map((ele) => (
                          <div>
                            <Image
                              url={documentTypeUrl.excel}
                              alt="logo"
                              handleClick={() => documentViewerHandler("xlsx")}
                            />
                          </div>
                        ))}
                      {getDocument
                        .filter((items) => items.type === "docx")
                        .map((ele) => (
                          <div>
                            <Image
                              url={documentTypeUrl.msWord}
                              alt="logo"
                              handleClick={() => documentViewerHandler("docx")}
                            />
                          </div>
                        ))}
                      {getDocument
                        .filter((items) => items.type === "pptx")
                        .map((ele) => (
                          <div>
                            <Image
                              url={documentTypeUrl.pptx}
                              alt="ppt-file"
                              handleClick={() => documentViewerHandler("pptx")}
                            />
                            <p>Power point file</p>
                          </div>
                        ))}
                      {getDocument
                        .filter((items) => items.type === "ppt")
                        .map((ele) => (
                          <div>
                            <Image
                              url={documentTypeUrl.ppt}
                              alt="ppt-file"
                              handleClick={() => documentViewerHandler("ppt")}
                            />
                            <p>Power point file</p>
                          </div>
                        ))}
                      {getDocument
                        .filter(
                          (items) =>
                            items.type &&
                            MediaTypes.imageTypes.includes(items.type)
                        )
                        .map((ele) => (
                          <div>
                            <img
                              style={{ width: "44px" }}
                              src={ele.name}
                              alt="course Image"
                              onClick={() => imagePreviewHandler(ele.type)}
                            />
                          </div>
                        ))}
                    </>
                  )}
                </>
              </div>
            )}
          </div>
          {status === true && (
            <>
              <div className="acknowledge-Course">
                <input
                  type="checkbox"
                  checked={chapterCompletion}
                  onChange={completionHandler}
                />
                <label>I acknowledge that I have completed this section.</label>
              </div>
            </>
          )}
        </div>
      )}

      {show && (
        <>
          {mapped &&
            mapped.length > 0 &&
            mapped.map((element) => (
              <>
                <ChapterDocument
                  url={element.name}
                  type={element.type}
                  show={show}
                  closeHandler={closeHandler}
                />
              </>
            ))}
        </>
      )}
      {isImageShow && (
        <>
          {mappedPreviewImage &&
            mappedPreviewImage.length > 0 &&
            mappedPreviewImage.map((element) => (
              <>
                <ChapterImagePreview
                  url={element.name}
                  type={element.type}
                  show={isImageShow}
                  closeHandler={imagePreviewCloseHandler}
                />
              </>
            ))}
        </>
      )}
    </div>
  );
};
export default CourseChapter;
